import _ from 'lodash';
import React, { useState } from 'react';
import { Form, Modal, Button } from 'rsuite';
import { loginService } from '../../../services';
import { validator } from '../../../helpers';
import roles from '../../../constants/roles/roles';

const seller = roles['seller.digital-origination'];
//
// Create seller user
//
export function CreateSellerDialog ({ show, onHide }) {
    //
    // States
    //

    // Form values states
    const [document, setDocument] = useState('');
    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    // const [role, setRole] = useState();
    // Loading state
    const [isLoading, setIsLoading] = useState(false);

    //
    // Funcions
    //
    const createUser = () => {
        // Validate all fields
        if (!validate()) {
            return false;
        }

        setIsLoading(true);

        // Build register data
        const data = {
            idPlatform: 8,
            idRole: seller,
            person: {
                attributes: [
                    {
                        description: 'first_name',
                        value: name
                    }, {
                        description: 'last_name',
                        value: lastname
                    }
                ],
                emails: [
                    {
                        idType: 1,
                        email: email
                    }
                ],
                documents: [
                    {
                        idType: 1,
                        document: document
                    }
                ]
            },
            fullname: `${name} ${lastname}`
        };

        loginService
            .register(data)
            .then(response => {
                // Alert.success('El usuario se creo correctamente.', 5000);
                alert('success', 'El usuario se creo correctamente.');
                onHide();
            })
            .catch(e => {
                console.error(e);
                alert('error', 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.');
                // Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const validate = () => {
        if (!validator.isInteger(document)) {
            // Alert.warning('Por favor, ingrese un documento valido.', 5000);
            alert('warning', 'Por favor, ingrese un documento valido.');
            return false;
        }
        if (!_.trim(name || '')) {
            // Alert.warning('Por favor, ingrese un nombre.', 5000);
            alert('warning', 'Por favor, ingrese un nombre.');
            return false;
        }
        if (!_.trim(lastname || '')) {
            // Alert.warning('Por favor, ingrese un Apellido.', 5000);
            alert('warning', 'Por favor, ingrese un Apellido.');
            return false;
        }
        if (!_.trim(email || '')) {
            // Alert.warning('Por favor, ingrese un Email.', 5000);
            alert('warning', 'Por favor, ingrese un Email.');
            return false;
        }
        // Check for valid email
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            // Alert.warning('Por favor, ingrese un Email valido.', 5000);
            alert('warning', 'Por favor, ingrese un Email valido.');
            return false;
        }
        // if (!role) {
        //     Alert.warning('Por favor, seleccione un Rol.', 5000);
        //     return false;
        // }
        return true;
    };

    //
    // Main component
    //

    return (
        <Modal
            // show={show}
            // onHide={onHide}
            open={show}
            onClose={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='user-create-modal'
        >
            <Modal.Header closeButton>
                <Modal.Title id='user-create-modal'>
                    {!isLoading && (<span>Crear Usuario</span>)}
                    {isLoading && <span>Creando Usuario...</span>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='py-1'>
                {!isLoading && (
                    <div className='row justify-content-center m-0'>
                        {/* <div className='row m-0'> */}
                        {/* TODO implementar el el field del helper */}
                        <div className='col-lg-8'>
                            <Form
                                fluid
                                formValue={{ name, lastname, document, email }}
                                onChange={() => {}}
                            >
                                <Form.Group>
                                    <Form.ControlLabel>DNI</Form.ControlLabel>
                                    <Form.Control
                                        name={'dni'}
                                        value={document}
                                        onChange={setDocument}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.ControlLabel>Nombre</Form.ControlLabel>
                                    <Form.Control
                                        name={'name'}
                                        value={name}
                                        onChange={setName}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.ControlLabel>Apellido</Form.ControlLabel>
                                    <Form.Control
                                        name={'lastName'}
                                        value={lastname}
                                        onChange={setLastname}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.ControlLabel>Email</Form.ControlLabel>
                                    <Form.Control
                                        name={'email'}
                                        value={email}
                                        onChange={setEmail}
                                    />
                                </Form.Group>
                                {/* <Form.Group>
                                    <Form.ControlLabel>Rol</Form.ControlLabel>
                                    <RadioGroup
                                        inline
                                        name='role'
                                        value={role}
                                        onChange={setRole}
                                    >
                                        <Radio value={roles['seller.digital-origination']}>Vendedor</Radio>
                                    </RadioGroup>
                                </Form.Group> */}
                            </Form>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <Button appearance='primary' disabled={isLoading} onClick={createUser} >Aceptar</Button>
                    <Button appearance='subtle' disabled={isLoading} onClick={onHide} >Cancelar</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
